module.exports = new __parcel__URL__("boss_fight_button_bg.e8f816b9.png").toString();